import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function BestSellerSales() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    const [totalSales, setTotalSales] = useState(0);
    const [totalNexusHydSale, setTotalNexusHydSale] = useState(0);
    const [totalInorbitSale, setTotalInorbitSale] = useState(0);
    const [totalLTSale, setTotalLTSale] = useState(0);
    const [totalOrionSale, setTotalOrionSale] = useState(0);
    const [totalPMCBLRSale, setTotalPMCBLRSale] = useState(0);
    const [totalShantiniketanSale, setTotalShantiniketanSale] = useState(0);
    const [totalUBCitySale, setTotalUBCitySale] = useState(0);
    const [totalVRSale, setTotalVRSale] = useState(0);
    const [totalPMCCHNSale, setTotalPMCCHNSale] = useState(0);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [totalbills, setTotalbills] = useState(0);
    useEffect(() => {
        // Calculate totals
        let totalSales = 0;
        let totalNexusHydSale = 0;
        let totalInorbitSale = 0;
        let totalLTSale = 0;
        let totalOrionSale = 0;
        let totalPMCBLRSale = 0;
        let totalShantiniketanSale = 0;
        let totalUBCitySale = 0;
        let totalVRSale = 0;
        let totalPMCCHNSale = 0;


        dataItem.forEach(item => {
            totalSales += item.TotalSales;
            totalNexusHydSale += item.NexusHydSale;
            totalInorbitSale += item.InorbitSale;
            totalLTSale += item.LTSale;
            totalOrionSale += item.OrionSale;
            totalPMCBLRSale += item.PMCBLRSale;
            totalShantiniketanSale += item.ShantiniketanSale;
            totalUBCitySale += item.UBCitySale;
            totalVRSale += item.VRSale;
            totalPMCCHNSale += item.PMCCHNSale;
        });

        setTotalSales(totalSales);
        setTotalNexusHydSale(totalNexusHydSale);
        setTotalInorbitSale(totalInorbitSale);
        setTotalLTSale(totalLTSale);
        setTotalOrionSale(totalOrionSale);
        setTotalPMCBLRSale(totalPMCBLRSale);
        setTotalShantiniketanSale(totalShantiniketanSale);
        setTotalUBCitySale(totalUBCitySale);
        setTotalVRSale(totalVRSale);
        setTotalPMCCHNSale(totalPMCCHNSale);

    }, [dataItem]);


    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            const branchId1 = 0;
            try {
                const response = await fetchData('ReportApi', `/BestSellerSales/${companyId}/${branchId1}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Daily Sales Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    // const handleExportExcel = () => {
    //     const categoryDataMap = {};

    //     // Group data by CategoryName (case-insensitive)
    //     filteredDataItem.forEach((rowData) => {
    //         const category = rowData.ItemCategory.toLowerCase(); // Convert CategoryName to lowercase
    //         if (!categoryDataMap[category]) {
    //             categoryDataMap[category] = [];
    //         }
    //         categoryDataMap[category].push(rowData);
    //     });

    //     const wb = XLSX.utils.book_new();

    //     // Create a sheet for all data (without grouping)
    //     const allDataSheet = createSheetData(filteredDataItem, 'All Data', true);
    //     XLSX.utils.book_append_sheet(wb, allDataSheet, 'All Data');

    //     // Create a sheet for each category
    //     Object.keys(categoryDataMap).forEach((category) => {
    //         const excelData = createSheetData(categoryDataMap[category], category.charAt(0).toUpperCase() + category.slice(1), true);
    //         XLSX.utils.book_append_sheet(wb, excelData, category.charAt(0).toUpperCase() + category.slice(1));
    //     });

    //     // Write the workbook to a file
    //     XLSX.writeFile(wb, 'BestSeller Sales Report.xlsx');
    // };

    // // Function to create sheet data with individual totals
    // const createSheetData = (dataItems, sheetName, includeTotal) => {
    //     const sheetData = [];
    //     const headerCaption = [`Best Seller Sales Report For: ${sheetName} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`];
    //     sheetData.push(headerCaption);

    //     const headerRow = [
    //         'Item Code', 'Item Name', 'MRP', 'Category', 'Group', 'Season Code', 'Size Code',
    //         'Discount', 'Total Portfolio Sales', 'Nexus Hyd Sale',
    //         'Inorbit Sale', 'L&T Sale', 'Orion Sale', 'PMC BLR Sale',
    //         'Shantiniketan Sale', 'UB City Sale', 'VR Sale', 'PMC CHN Sale'
    //     ];
    //     sheetData.push(headerRow);

    //     let totals = {
    //         totalSales: 0,
    //         totalNexusHydSale: 0,
    //         totalInorbitSale: 0,
    //         totalLTSale: 0,
    //         totalOrionSale: 0,
    //         totalPMCBLRSale: 0,
    //         totalShantiniketanSale: 0,
    //         totalUBCitySale: 0,
    //         totalVRSale: 0,
    //         totalPMCCHNSale: 0,
    //     };

    //     dataItems.forEach((rowData) => {
    //         const dataRow = [
    //             rowData.ItemCode,
    //             rowData.ItemName,
    //             rowData.MRP,
    //             rowData.CategoryName,
    //             rowData.GroupName,
    //             rowData.SeasonCode,
    //             rowData.SizeCode,
    //             rowData.Discount,
    //             rowData.TotalSales,
    //             rowData.NexusHydSale,
    //             rowData.InorbitSale,
    //             rowData.LTSale,
    //             rowData.OrionSale,
    //             rowData.PMCBLRSale,
    //             rowData.ShantiniketanSale,
    //             rowData.UBCitySale,
    //             rowData.VRSale,
    //             rowData.PMCCHNSale,
    //         ];
    //         sheetData.push(dataRow);

    //         // Update total values
    //         totals.totalSales += rowData.TotalSales;
    //         totals.totalNexusHydSale += rowData.NexusHydSale;
    //         totals.totalInorbitSale += rowData.InorbitSale;
    //         totals.totalLTSale += rowData.LTSale;
    //         totals.totalOrionSale += rowData.OrionSale;
    //         totals.totalPMCBLRSale += rowData.PMCBLRSale;
    //         totals.totalShantiniketanSale += rowData.ShantiniketanSale;
    //         totals.totalUBCitySale += rowData.UBCitySale;
    //         totals.totalVRSale += rowData.VRSale;
    //         totals.totalPMCCHNSale += rowData.PMCCHNSale;
    //     });

    //     // Add total row for each sheet
    //     const totalRow = ['', '', '', '', '', '', '', 'Total', totals.totalSales, totals.totalNexusHydSale, totals.totalInorbitSale, totals.totalLTSale, totals.totalOrionSale, totals.totalPMCBLRSale, totals.totalShantiniketanSale, totals.totalUBCitySale, totals.totalVRSale, totals.totalPMCCHNSale];
    //     sheetData.push(totalRow);

    //     return XLSX.utils.aoa_to_sheet(sheetData);
    // };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();

        // Group data by category
        const categoryDataMap = {};
        filteredDataItem.forEach((rowData) => {
            const category = (rowData.ItemCategory || 'Unnamed').toLowerCase();
            if (!categoryDataMap[category]) {
                categoryDataMap[category] = [];
            }
            categoryDataMap[category].push(rowData);
        });

        // Create "All Data" sheet
        createSheetData(workbook, filteredDataItem, 'All Data', true);

        // Create each category sheet
        Object.keys(categoryDataMap).forEach((category) => {
            const sheetName = category.charAt(0).toUpperCase() + category.slice(1);
            createSheetData(workbook, categoryDataMap[category], sheetName, true);
        });

        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'BestSeller Sales Report.xlsx');
    };

    // Function to create a styled sheet
    const createSheetData = (workbook, dataItems, sheetName, includeTotal) => {
        const worksheet = workbook.addWorksheet(sheetName);

        const rightAlignColumns = [
            'MRP', 'Discount', 'Total Portfolio Sales', 'Nexus Hyd Sale',
            'Inorbit Sale', 'L&T Sale', 'Orion Sale', 'PMC BLR Sale',
            'Shantiniketan Sale', 'UB City Sale', 'VR Sale', 'PMC CHN Sale'
        ];

        // Caption Row
        const headerCaption = `Best Seller Sales Report For: ${sheetName} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`;
        worksheet.mergeCells('A1:R1');
        const captionCell = worksheet.getCell('A1');
        captionCell.value = headerCaption;
        captionCell.font = { bold: true, size: 14 };
        captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        // Header Row
        const headerRowValues = [
            'Item Code', 'Item Name', 'MRP', 'Category', 'Group', 'Season Code', 'Size Code',
            'Discount', 'Total Portfolio Sales', 'Nexus Hyd Sale',
            'Inorbit Sale', 'L&T Sale', 'Orion Sale', 'PMC BLR Sale',
            'Shantiniketan Sale', 'UB City Sale', 'VR Sale', 'PMC CHN Sale'
        ];
        const headerRow = worksheet.addRow(headerRowValues);

        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.columns = headerRowValues.map(() => ({ width: 18 }));

        // Totals object
        let totals = {
            totalSales: 0, totalNexusHydSale: 0, totalInorbitSale: 0, totalLTSale: 0,
            totalOrionSale: 0, totalPMCBLRSale: 0, totalShantiniketanSale: 0,
            totalUBCitySale: 0, totalVRSale: 0, totalPMCCHNSale: 0
        };

        // Data Rows
        dataItems.forEach((rowData) => {
            const rowValues = [
                rowData.ItemCode, rowData.ItemName, parseFloat(rowData.MRP),
                rowData.CategoryName, rowData.GroupName, rowData.SeasonCode, rowData.SizeCode,
                parseFloat(rowData.Discount), parseFloat(rowData.TotalSales),
                parseFloat(rowData.NexusHydSale), parseFloat(rowData.InorbitSale),
                parseFloat(rowData.LTSale), parseFloat(rowData.OrionSale),
                parseFloat(rowData.PMCBLRSale), parseFloat(rowData.ShantiniketanSale),
                parseFloat(rowData.UBCitySale), parseFloat(rowData.VRSale),
                parseFloat(rowData.PMCCHNSale)
            ];

            const row = worksheet.addRow(rowValues);

            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });

            // Totals
            totals.totalSales += rowData.TotalSales;
            totals.totalNexusHydSale += rowData.NexusHydSale;
            totals.totalInorbitSale += rowData.InorbitSale;
            totals.totalLTSale += rowData.LTSale;
            totals.totalOrionSale += rowData.OrionSale;
            totals.totalPMCBLRSale += rowData.PMCBLRSale;
            totals.totalShantiniketanSale += rowData.ShantiniketanSale;
            totals.totalUBCitySale += rowData.UBCitySale;
            totals.totalVRSale += rowData.VRSale;
            totals.totalPMCCHNSale += rowData.PMCCHNSale;
        });

        // Total Row
        if (includeTotal) {
            const totalRowValues = [
                '', '', '', '', '', '', '', 'Total',
                totals.totalSales, totals.totalNexusHydSale, totals.totalInorbitSale,
                totals.totalLTSale, totals.totalOrionSale, totals.totalPMCBLRSale,
                totals.totalShantiniketanSale, totals.totalUBCitySale,
                totals.totalVRSale, totals.totalPMCCHNSale
            ];
            const totalRow = worksheet.addRow(totalRowValues);
            totalRow.font = { bold: true };

            totalRow.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });
        }

        
        return worksheet;
    };



    const handlePrint = () => {

    };

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Best eller Sales Report
                    </h6>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '55px' }}>

                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px' }}
                            />
                        )}
                    </div>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item Code </TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Group</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Season Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Size Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Discount</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Total Portfolio Sales</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Nexus Hyd Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Inorbit Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>L&T Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Orion Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PMC BLR Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Shantiniketan Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>UB City Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>VR Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PMC CHN Sale</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '5px',
                                        height: '52px',

                                        backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ItemCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ItemName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.MRP}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ItemCategory}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.SeasonCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.SizeCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.Discount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.TotalSales}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.NexusHydSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.InorbitSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.LTSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.OrionSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.PMCBLRSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.ShantiniketanSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.UBCitySale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.VRSale}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{data.PMCCHNSale}</TableCell>

                                </TableRow>
                            ))}


                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '40px',

                                    backgroundColor: 'teal',

                                }}
                            >
                                <TableCell colSpan={7} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '14px', textTransform: 'uppercase' }}>Total</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalSales}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalNexusHydSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalInorbitSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalLTSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalOrionSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalPMCBLRSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalShantiniketanSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalUBCitySale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalVRSale}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalPMCCHNSale}</TableCell>


                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default BestSellerSales;
